import { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useT } from "@/i18n";
import { usePageMeta, shortDate } from "@/lib/format";
import { Spinner } from "@/components/Spinner";
import { EmptyState } from "@/components/EmptyState";
import { ChevronLeft, ChevronRight, CalendarDays, Sparkles } from "lucide-react";

export default function EvaDigests() {
  const t = useT();
  usePageMeta(t("weva_digests_title"));
  const navigate = useNavigate();
  const [items, setItems] = useState(null);

  const load = useCallback(async () => {
    try { const { data } = await api.get("/eva/digests", { params: { limit: 50 } }); setItems(Array.isArray(data) ? data : []); }
    catch { setItems([]); }
  }, []);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="space-y-5" data-testid="eva-digests">
      <button onClick={() => navigate("/app/weva")} data-testid="digests-back" className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground">
        <ChevronLeft className="h-4 w-4" /> {t("weva")}
      </button>
      <div>
        <h1 className="font-display text-2xl text-foreground">{t("weva_digests_title")}</h1>
        <p className="mt-1 text-sm text-muted-foreground">{t("weva_digests_sub")}</p>
      </div>

      {items === null ? (
        <Spinner label={t("common.loading")} />
      ) : items.length === 0 ? (
        <EmptyState icon={CalendarDays} title={t("weva_digests_empty")} />
      ) : (
        <div className="space-y-2.5">
          {items.map((d) => (
            <Link key={d.id} to={`/app/weva/digest/${d.id}`} data-testid={`digest-${d.id}`}
              className="flex items-center gap-3 rounded-2xl border border-border bg-card p-4 transition-colors hover:bg-accent/30">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary/10">
                <Sparkles className="h-5 w-5 text-primary" />
              </span>
              <div className="min-w-0 flex-1">
                <p className="text-xs text-muted-foreground">{shortDate(d.created_at)}{d.mood ? ` · ${d.mood}` : ""}</p>
                <p className="mt-0.5 line-clamp-2 text-sm text-foreground">{d.summary || t("weva_didn_t_leave_a_summary_for_this")}</p>
              </div>
              <ChevronRight className="h-4 w-4 shrink-0 text-muted-foreground" />
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
